module.exports = __webpack_public_path__ + "img/heater-house.431590e.jpg";